const createFavoriteAssetsAnalyticsPlugin = ({ analytics, favoriteAssetsAtom }) => {
  let subscriptions = []

  const onStart = () => {
    analytics.requireDefaultEventProperties(['numberOfAssetsFavorites'])

    const unsubscribeFavoriteAssetsAtom = favoriteAssetsAtom.observe((favorites) => {
      const numberOfAssetsFavorites = favorites
        ? Object.values(favorites).filter(Boolean).length
        : 0
      analytics.setDefaultEventProperties({ numberOfAssetsFavorites })
    })

    subscriptions = [unsubscribeFavoriteAssetsAtom]
  }

  const onStop = () => {
    subscriptions.forEach((unsubscribe) => unsubscribe())
  }

  return { onStart, onStop }
}

export default createFavoriteAssetsAnalyticsPlugin
